import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { WithLazy } from "@quintype/components";
import { string, number, object } from "prop-types";

import DfpAd from "../../dfp-ad";

import "./ads.m.css";

const getSlotId = (id, name) => {
  switch (name) {
    case "quint":
      return `tq_${id}`;
    case "quint-hindi":
      return `hq_${id}`;
    case "fit":
      return `fit_${id}`;
    default:
      return `tq_${id}`;
  }
};

const AdSlotBase = ({ id, publisherName, isActivePlan, ...props }) => {
  if (isActivePlan) return null;

  const slotId = getSlotId(id, publisherName);

  return (
    <WithLazy margin="300px">
      {() => (
        <div>
          <DfpAd adtype={slotId} {...props} />
        </div>
      )}
    </WithLazy>
  );
};

AdSlotBase.propTypes = {
  isActivePlan: number,
  id: string,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  isActivePlan: get(state, ["userReducer", "isActivePlan"], 0),
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const AdSlot = connect(mapStateToProps, null)(AdSlotBase);

const proptypeSet1 = {
  mobile: string,
  desktop: string,
  story: object,
};

const proptypeSet2 = {
  id: string,
  story: object,
};

const QuintTopResponsiveContainer = ({ desktop, mobile }) => {
  return (
    <div styleName="quint-top-ad ad">
      <div styleName="desktop">
        <AdSlot id={desktop} />
      </div>
      <div styleName="mobile">
        <AdSlot id={mobile} />
      </div>
    </div>
  );
};

QuintTopResponsiveContainer.propTypes = proptypeSet1;

const QuintStickyContainer = ({ id }) => {
  return (
    <div styleName="">
      <AdSlot id={id} />
    </div>
  );
};

QuintStickyContainer.propTypes = proptypeSet2;

const Standard337x280Container = ({ id, story = {} }) => {
  return (
    <div styleName="standard-337x280 ad" className="standard-337x280">
      <AdSlot id={id} story={story} />
    </div>
  );
};

Standard337x280Container.propTypes = proptypeSet2;

const Standard300x260Container = ({ id }) => {
  return (
    <div styleName="standard-300x260 ad" className="standard-300x260">
      <AdSlot id={id} />
    </div>
  );
};

Standard300x260Container.propTypes = proptypeSet2;

const Standard337x600Container = ({ id }) => {
  return (
    <div styleName="standard-337x600 ad" className="standard-337x600">
      <AdSlot id={id} />
    </div>
  );
};

Standard337x600Container.propTypes = proptypeSet2;

const StoryTopResponsiveContainer = ({ desktop, mobile, story }) => {
  return (
    <div styleName="story-top-ad ad">
      <div styleName="desktop">
        <AdSlot id={desktop} story={story} />
      </div>
      <div styleName="mobile">
        <AdSlot id={mobile} story={story} />
      </div>
    </div>
  );
};

StoryTopResponsiveContainer.propTypes = proptypeSet1;

const StoryResponsiveContainer = ({ desktop, mobile, story }) => {
  return (
    <div styleName="story-content ad">
      <div styleName="desktop">
        <AdSlot id={desktop} story={story} />
      </div>
      <div styleName="mobile">
        <AdSlot id={mobile} story={story} />
      </div>
    </div>
  );
};

StoryResponsiveContainer.propTypes = proptypeSet1;

const OutOfPageAd = () => <AdSlot id="outOfPage" />;

const OutOfPageAdB = () => <AdSlot id="outOfPageB" />;

export {
  QuintTopResponsiveContainer,
  Standard337x280Container,
  Standard337x600Container,
  Standard300x260Container,
  StoryTopResponsiveContainer,
  StoryResponsiveContainer,
  OutOfPageAd,
  OutOfPageAdB,
  AdSlot,
};
